import { downloadFile } from '../utils/utils';

export default {
    data() {
        return {
            documentTypeToPropertyMap: {
                SD1: 'employmentContract',
                SD2: 'employmentContractOrTrainingAgreement',
                SD3: 'insuranceCertificate',
                SD4: 'additionalHealthService',
                SD5: 'collectiveInsuranceOrCoverageCertificate',
                SD6: 'responsableHealthCertificate',
                SD7: 'individualHealthCertificate',
                SD8: 'swornStatement'
            }
        };
    },
    methods: {
        processDocuments(documents) {
            for (const document of documents) {
                this.matchDocument(document)
            }
        },
        reasonContainDocumentType(documentTypeCode) {
            return this.chosenReason &&
                this.chosenReason.documentTypes.find(
                    documentType => {
                        return documentType.code === documentTypeCode
                    })
                ;
        },
        addDocument(event, documentTypeCode) {
            let isUpdate = false;
            this.exemptionReason.documents.find(document => {
                if (document.typeCode === documentTypeCode) {
                    document.content = event.target.files[0];
                    isUpdate = true;
                }
            });
            if (!isUpdate) {
                this.exemptionReason.documents.push({
                    typeCode: documentTypeCode,
                    content: event.target.files[0]
                });
            }
            this.$emit('update:exemptionReason', this.exemptionReason)
        },
        deleteDocument(documentTypeCode) {
            for (let [i, value] of this.exemptionReason.documents.entries()) {
                if (documentTypeCode === value.typeCode) {
                    this.exemptionReason.documents.splice(i, 1);
                    break;
                }
            }
            this.clearData(documentTypeCode);
        },
        async downloadLocalFile(documentName) {
            await downloadFile(this[documentName]);
        },
        matchDocument(document) {
            switch (document.typeCode) {
                case 'SD1':
                    this.employmentContract = document;
                    break;
                case 'SD2':
                    this.employmentContractOrTrainingAgreement = document;
                    break;
                case 'SD3':
                    this.insuranceCertificate = document;
                    break;
                case 'SD4':
                    this.additionalHealthService = document;
                    break;
                case 'SD5':
                    this.collectiveInsuranceOrCoverageCertificate = document;
                    break;
                case 'SD6':
                    this.responsableHealthCertificate = document;
                    break;
                case 'SD7':
                    this.individualHealthCertificate = document;
                    break
                case 'SD8':
                    this.swornStatement = document;
                    break
            }
        },
        clearData(documentTypeCode) {
            switch (documentTypeCode) {
                case 'SD1':
                    this.employmentContract = null;
                    break;
                case 'SD2':
                    this.employmentContractOrTrainingAgreement = null;
                    break;
                case 'SD3':
                    this.insuranceCertificate = null;
                    break;
                case 'SD4':
                    this.additionalHealthService = null;
                    break;
                case 'SD5':
                    this.collectiveInsuranceOrCoverageCertificate = null;
                    break;
                case 'SD6':
                    this.responsableHealthCertificate = null;
                    break;
                case 'SD7':
                    this.individualHealthCertificate = null;
                    break
                case 'SD8':
                    this.swornStatement = null;
                    break
            }
        }
    }
}
